import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { get } from 'lodash';
import { InfoLabel } from '../../../../../../common/components';
import displayName from '../../../../../../helpers/displayName';
import './styles.scss';

const Travellers = ({ resource, productCode }) => {
  if (productCode === 'SL') {
    // no travellers on smart luggage
    return null;
  }

  const getTravellerOptions = (traveller) => {
    const options = get(traveller, 'metadata.options', []);
    const optionKeys = Object.keys(options);
    const selectedOptions = optionKeys
      .filter((optionKey) => !!options[optionKey])
      .map((optionKey) => displayName(optionKey));
    return selectedOptions.join(', ');
  };

  const smokerMap = {
    smoker: 'Yes I’m a smoker',
    non_smoker: 'No, never smoked',
    non_smoker_lt2_years: 'Ex smoker - less than 2 years',
    non_smoker_gt2_years: 'Ex smoker - 2 or more years',
  };

  return (
    <div>
      <div className="section-title">
        <h4>Travellers</h4>
      </div>
      {get(resource, 'data.attributes.metadata.adults', []).map((traveller, i) => (
        <Row key={i} className="traveller-section">
          <Row>
            <Col sm={6}>
              <InfoLabel
                label={'Adult ' + (i + 1)}
                value={
                  traveller.title + ' ' + traveller.first_name + ' ' + traveller.last_name
                }
                labelSize={4}
                wrapperClass={'clear-margin'}
              />
            </Col>
            <Col sm={6}>
              <InfoLabel
                label="DOB"
                value={traveller.dob}
                labelSize={4}
                wrapperClass={'clear-margin'}
              />
            </Col>
            <Col sm={6}>
              <InfoLabel
                label="Medical Conditions"
                value={
                  traveller.screening
                    ? get(traveller, 'screening.meta.conditions', []).join(', ')
                    : ''
                }
                labelSize={4}
                wrapperClass={'clear-margin'}
              />
              {!get(traveller, 'conditions_covered', false) &&
                get(traveller, 'screening.meta', false) && (
                  <div className="row">
                    <div className="col-sm-12 col-sm-offset-4">
                      <p className="medical-excluded-title">
                        Medical Conditions Excluded - No Cover.
                      </p>
                    </div>
                  </div>
                )}
            </Col>
            <Col sm={6}>
              <InfoLabel
                label="Individual Options"
                value={getTravellerOptions(traveller)}
                labelSize={4}
                wrapperClass={'clear-margin'}
              />
            </Col>

            {productCode === 'CC' && (
              <Col sm={6}>
                <InfoLabel
                  label="Smoker Status"
                  value={
                    traveller.is_smoker
                      ? smokerMap[traveller.is_smoker.replace(/-/g, '_')]
                      : ''
                  }
                  labelSize={4}
                  wrapperClass={'clear-margin'}
                />
              </Col>
            )}
          </Row>
        </Row>
      ))}
      {get(resource, 'data.attributes.metadata.children', []).map((traveller, i) => (
        <Row key={i} className="traveller-section">
          <div className="form-horizontal">
            <Row>
              <Col sm={6}>
                <InfoLabel
                  label={'Child ' + (i + 1)}
                  value={
                    traveller.title +
                    ' ' +
                    traveller.first_name +
                    ' ' +
                    traveller.last_name
                  }
                  labelSize={4}
                  wrapperClass={'clear-margin'}
                />
              </Col>
              <Col sm={6}>
                <InfoLabel
                  label="DOB"
                  value={traveller.dob}
                  labelSize={4}
                  wrapperClass={'clear-margin'}
                />
              </Col>
              <Col sm={6}>
                <InfoLabel
                  label="Medical Conditions"
                  value={
                    traveller.screening
                      ? get(traveller, 'screening.meta.conditions', []).join(', ')
                      : ''
                  }
                  labelSize={4}
                  wrapperClass={'clear-margin'}
                />
                {!traveller.conditions_covered &&
                  get(traveller, 'screening.meta', false) && (
                    <div className="row">
                      <div className="col-sm-12 col-sm-offset-4">
                        <p className="medical-excluded-title">
                          Medical Conditions Excluded - No Cover.
                        </p>
                      </div>
                    </div>
                  )}
              </Col>
              <Col sm={6}>
                <InfoLabel
                  label="Individual Options"
                  value={getTravellerOptions(traveller)}
                  labelSize={4}
                  wrapperClass={'clear-margin'}
                />
              </Col>
            </Row>
          </div>
        </Row>
      ))}
      <div className="hr" />
    </div>
  );
};
export default Travellers;
